import {GeofenceType, geofenceType} from '../constants/geofence-type.constant';
import * as L from 'leaflet';
import {circle, geoJSON} from 'leaflet';
import {ImmutableListRepositoryService} from '../../../lib/gelios-field/immutable-list-repository.service';

const COLORS = {
  [geofenceType.RIDE_ALLOW]: {color: '#00BD1E', fillColor: '#00BD1E', opacity: 0.5, fillOpacity: 0.3},
  [geofenceType.RIDE_RESTRICT]: {color: '#FF3434', fillColor: '#FF3434', opacity: 0.5, fillOpacity: 0.3},
  [geofenceType.FINISH_ALLOW]: {color: '#726FFC', fillColor: '#726FFC', opacity: 0.5, fillOpacity: 0.6},
  [geofenceType.FINISH_RESTRICT]: {color: '#ff00ff', fillColor: '#ff00ff', opacity: 0.5, fillOpacity: 0.3},
  [geofenceType.TECH_WORK_AREA]: {color: '#464647', fillColor: '#464647', opacity: 1, fillOpacity: 0.2},
  [geofenceType.SPEED_LIMIT]: {color: '#FF9800', fillColor: '#FF9800', opacity: 0.2, fillOpacity: 0.5},
  [geofenceType.DEMAND]: {color: '#00ffd0', fillColor: '#00ffd0', opacity: 0.2, fillOpacity: 0.5},
};

export class GeofenceHelper {
  static getIcon(type: string, isBonus = false) {
    const finalType = isBonus ? 'parking_bonus' : type;

    return `icon icon-geofence-type icon-${finalType}`;
  }

  static getIconLayer(type: string) {
    return `icon geofence-type-layer ic-${type}`;
  }

  static getTitle(type: string, immutableList: ImmutableListRepositoryService) {
    return type ? immutableList.getItemById('geofence-type', type) : '';
  }

  static getColor(type: GeofenceType) {
    return COLORS[type];
  }

  static createGeofenceLayer(g: any, paneOverride?: string) {
    const paneName = paneOverride || g.type;

    g.layer = geoJSON(
      JSON.parse(g.geometry),
      {
        pointToLayer: (geoJsonPoint, latlng) => {
          // @ts-ignore
          return circle(latlng, {
            radius: g.radius,
            pmIgnore: true,
            pane: paneName
          });
        },
        // @ts-ignore
        pmIgnore: true,
        pane: paneName
      }
    ).getLayers()[0];
    if (g.layer.getLatLngs && g.layer.getLatLngs()[0].lat) {
      // @ts-ignore
      g.layer = L.corridor(
        g.layer.getLatLngs(),
        {
          color: GeofenceHelper.getColor(g.type).color,
          fillColor: GeofenceHelper.getColor(g.type).fillColor,
          opacity: GeofenceHelper.getColor(g.type).opacity,
          stroke: true,
          corridor: g.radius,
          pmIgnore: true,
          pane: paneName
        }
      );
    }
    g.layer.setStyle({
      color: GeofenceHelper.getColor(g.type).color,
      fillColor: GeofenceHelper.getColor(g.type).fillColor,
      opacity: GeofenceHelper.getColor(g.type).opacity,
      fillOpacity: GeofenceHelper.getColor(g.type).fillOpacity
    }).bindPopup(
      '<b>' + g.name + '</b>' + '<br /><span>' + (g.description ? g.description : '') + '</span>'
    );

    return g;
  }

  static getLayerArea(layer: any): number {
    if (!layer || typeof layer.getBounds !== 'function') {
      return Number.MAX_SAFE_INTEGER;
    }

    const bounds = layer.getBounds();
    if (!bounds || (typeof bounds.isValid === 'function' && !bounds.isValid())) {
      return Number.MAX_SAFE_INTEGER;
    }

    const ne = typeof bounds.getNorthEast === 'function' ? bounds.getNorthEast() : bounds._northEast;
    const sw = typeof bounds.getSouthWest === 'function' ? bounds.getSouthWest() : bounds._southWest;

    if (!ne || !sw || ne.lat === undefined || sw.lat === undefined) {
      return Number.MAX_SAFE_INTEGER;
    }

    return (ne.lat - sw.lat) * (ne.lng - sw.lng);
  }
}

